// Animation utilities for Framer Motion
export const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: 'easeOut' }
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 0.4, ease: 'easeOut' }
};

export const slideInRight = {
  initial: { opacity: 0, x: 30 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.5, ease: 'easeOut' }
};

export const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3,
    }
  }
};

export const staggerItem = {
  initial: { opacity: 0, y: 20 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.5, ease: 'easeOut' }
  }
};

export const scaleOnHover = {
  rest: { scale: 1 },
  hover: { 
    scale: 1.05,
    transition: { duration: 0.2, ease: 'easeOut' }
  }
};

export const magneticHover = {
  rest: { scale: 1, rotate: 0 },
  hover: { 
    scale: 1.05,
    transition: { duration: 0.2, ease: 'easeOut' }
  }
};

export const tiltOnHover = {
  rest: { rotateX: 0, rotateY: 0 },
  hover: { 
    rotateX: -5,
    rotateY: 5,
    transition: { duration: 0.3, ease: 'easeOut' }
  }
};

export const glowEffect = {
  rest: { boxShadow: '0 0 0 rgba(247, 148, 29, 0)' },
  hover: { 
    boxShadow: '0 0 20px rgba(247, 148, 29, 0.4)',
    transition: { duration: 0.3, ease: 'easeOut' }
  }
};

export const splitTextVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.02,
      delayChildren: 0.2,
    }
  }
};

export const splitCharVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: 'easeOut' }
  }
};

export const navbarVariants = {
  transparent: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    backdropFilter: 'blur(0px)',
    height: '80px',
    transition: { duration: 0.3, ease: 'easeOut' }
  },
  solid: {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    backdropFilter: 'blur(16px)',
    height: '64px',
    transition: { duration: 0.3, ease: 'easeOut' }
  }
};

export const cardVariants = {
  rest: { 
    y: 0,
    rotateX: 0,
    rotateY: 0,
    scale: 1,
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  },
  hover: { 
    y: -8,
    rotateX: -2,
    rotateY: 2,
    scale: 1.02,
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    transition: { duration: 0.3, ease: 'easeOut' }
  }
};

export const buttonVariants = {
  rest: { 
    scale: 1,
    boxShadow: '0 0 0 rgba(247, 148, 29, 0)',
  },
  hover: { 
    scale: 1.05,
    boxShadow: '0 0 20px rgba(247, 148, 29, 0.3)',
    transition: { duration: 0.2, ease: 'easeOut' }
  },
  tap: { 
    scale: 0.95,
    transition: { duration: 0.1, ease: 'easeOut' }
  }
};

export const pageTransition = {
  initial: { opacity: 0, y: 20 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' }
  },
  exit: { 
    opacity: 0, 
    y: -20,
    transition: { duration: 0.3, ease: 'easeIn' }
  }
};

// Parallax scroll utility
export const useParallaxScroll = () => {
  let ticking = false;
  const isMobile = window.innerWidth <= 768;
  
  const updateParallax = () => {
    if (isMobile) return; // Disable parallax on mobile for performance
    
    if (!ticking) {
      requestAnimationFrame(() => {
        const scrolled = window.pageYOffset;
        const parallaxElements = document.querySelectorAll('.parallax-gif-bg');
        
        parallaxElements.forEach(element => {
          const speed = 0.5;
          const yPos = -(scrolled * speed);
          element.style.transform = `translate3d(0, ${yPos}px, 0)`;
        });
        
        ticking = false;
      });
      
      ticking = true;
    }
  };

  return { updateParallax };
};